import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AnnouncementSlider from "../../Components/AnnouncementSlider";
import AchievementCard from "../../Components/AchievementCard";
import { USER_TYPES, USER_TYPES_CATEGORIES } from "../../constants/globals";
import {
  adminIndicatorsApi,
  partnerAchievementsApi,
  showNotificationForRenew,
} from "../../apis";
import Loader from "../../Components/Loader";
import { Link } from "react-router-dom";
import ErrorAnimationComponent from "../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import SubscriptionRenewalReminder from "../../Components/SubscriptionRenewalReminder";
import PointsToVoucherCard from "../../Components/PointsToVoucherCard/PointsToVoucherCard";

const Dashboard = () => {
  const { loggedInUser } = useSelector((state) => state?.Auth);
  const currentUserType = loggedInUser?.data?.model?.user_type_id;
  const [indicators, setIndicators] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const [isError, setIsError] = useState();
  const [achievements, setAchievements] = useState([]);
  const [announcements, setAnnouncements] = useState({});
  const [
    showNotificationForRenewSubscription,
    setShowNotificationForRenewSubscription,
  ] = useState(false);
  const [packageExpireDate, setPackageExpireDate] = useState("");

  const currentClientCategory =
    loggedInUser?.data?.model?.client?.client_category_id;

  useEffect(() => {
    if (currentUserType === USER_TYPES.PARTNER) {
      showNotificationForRenew()
        .then((response) => {
          setShowNotificationForRenewSubscription(
            response.data.data.showExpireSoonAlert
          );
          setPackageExpireDate(response.data.data.packageExpireDate);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [currentUserType]);

  const fetchIndicators = async () => {
    try {
      setIsLoading(true);
      const response = await adminIndicatorsApi();
      if (response.data.status) {
        setIndicators(Object.values(response.data.data || {}));
      } else {
        console.error("Failed to fetch indicators:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching indicators:", error);
      setIsError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAchievements = async () => {
    try {
      setIsLoading(true);
      const response = await partnerAchievementsApi();
      if (response.data.status) {
        const { announcements, ...otherData } = response.data.data || {};
        setAnnouncements(announcements);
        setAchievements(Object.values(otherData));
      } else {
        console.error("Failed to fetch indicators:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching indicators:", error);
      setIsError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      currentUserType === USER_TYPES.ADMIN ||
      currentUserType === USER_TYPES.MODERATOR
    ) {
      fetchIndicators();
    }
    if (currentUserType === USER_TYPES.PARTNER) {
      fetchAchievements();
    }
  }, [currentUserType]);

  const borderStyles = [
    "tw-border-red-400",
    "tw-border-blue-400",
    "tw-border-yellow-400",
    "tw-border-green-400",
  ];
  const pointingWallet = achievements.find(
    (a) => a.title === "Pointing Wallet"
  )?.value;

  const calculateCustomValueClasses = (indicator) => {
    if (indicator.title === "Total Registration Wallet") {
      // return totalRegistrationWallet !== eMoneyCreation - +eMoneyUsed
      //   ? "tw-text-red-500 tw-font-bold"
      //   : "tw-text-green-500 tw-font-bold";
    }
    return "";
  };

  if (isLoading) return <Loader />;

  if (isError) return <ErrorAnimationComponent message={isError} />;

  return (
    <div className="tw-mb-5">
      {(currentUserType === USER_TYPES.ADMIN ||
        currentUserType === USER_TYPES.MODERATOR) &&
        currentUserType !== USER_TYPES.PARTNER && (
          <>
            <h2 className="h4 mt-3 tw-mb-5">Latest Indicators</h2>
            {!isLoading && (
              <div className="row row-cols-sm-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-3 g-2 g-lg-4">
                {!!indicators.length ? (
                  indicators.map((indicator, index) => (
                    <AchievementCard
                      key={index}
                      title={indicator.title}
                      count={indicator.value}
                      unit={indicator.unit}
                      icon={indicator.icon}
                      borderClasses={borderStyles[index % 4]}
                      customValueClasses={calculateCustomValueClasses(
                        indicator
                      )}
                    />
                  ))
                ) : (
                  <p className="!tw-mt-4">No indicators found.</p>
                )}
              </div>
            )}
          </>
        )}

      {currentUserType === USER_TYPES.PARTNER && (
        <>
          <SubscriptionRenewalReminder
            packageExpireDate={packageExpireDate}
            showNotification={showNotificationForRenewSubscription}
            setShowNotificationForRenewSubscription={
              setShowNotificationForRenewSubscription
            }
          />

          <h2 className="h4 mt-3 tw-mb-5">Join us on</h2>

          <div className="d-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6 tw-mb-5">
            {(currentClientCategory ===
              USER_TYPES_CATEGORIES.SERVICE_MARKETING ||
              currentClientCategory === USER_TYPES_CATEGORIES.SERVICE_ONLY) && (
              <>
                {/* <div
                  className={`d-flex w-100 align-items-stretch justify-content-center tw-h-[120px] `}
                >
                  <Link
                    to="https://t.me/+KxXXt37dzR9mYmM0"
                    target="_blank"
                    className={`tw-bg-white tw-shadow-md w-100 tw-py-4 tw-px-2 tw-border-l-4 tw-border-red-900`}
                  >
                    <img
                      src="/imgs/unite_signals.png"
                      className="tw-size-full tw-object-contain"
                      alt=""
                    />
                  </Link>
                </div> */}
                <div
                  className={`d-flex w-100  align-items-stretch justify-content-center tw-h-[120px]`}
                >
                  <Link
                    to="https://t.me/+LFWFACdokfM0Njdk"
                    target="_blank"
                    className={`tw-bg-white tw-shadow-md w-100 tw-pb-6 tw-px-2 tw-border-l-4 tw-border-primary !tw-no-underline`}
                  >
                    <img
                      src="/imgs/logoJoinUs.png"
                      className="tw-size-full tw-object-contain"
                      alt=""
                    />
                    <h4 className="tw-text-center tw-font-bold !tw-pb-2 ">
                      UNITERS ACADEMY
                    </h4>
                  </Link>
                </div>
                <div
                  className={`d-flex w-100 align-items-stretch justify-content-center tw-h-[120px] `}
                >
                  <Link
                    to="https://t.me/+aKzt6djdKW1kOTI0"
                    target="_blank"
                    className={`tw-bg-white tw-shadow-md w-100 tw-py-4 tw-px-2 tw-border-l-4 tw-border-yellow-400`}
                  >
                    <img
                      src="/imgs/unite_black.png"
                      className="tw-size-full tw-object-contain"
                      alt=""
                    />
                  </Link>
                </div>
              </>
            )}

            {currentClientCategory === USER_TYPES_CATEGORIES.NEWCOMER && (
              <div
                className={`d-flex w-200 align-items-stretch justify-content-center tw-h-[280px]`}
              >
                <Link
                  to="https://t.me/+bwyDza8p1Z0yYTFk"
                  target="_blank"
                  className={`tw-bg-white tw-shadow-md w-100 tw-py-0 tw-px-0 tw-border-l-4 tw-border-red-900`}
                >
                  <img
                    src="/imgs/New_Comer.png"
                    className="tw-size-full tw-object-contain"
                    alt="New comer winlife"
                  />
                </Link>
              </div>
            )}
          </div>

          <h2 className="h4">Announcements</h2>
          {!!announcements?.data?.length ? (
            <AnnouncementSlider announcements={announcements.data} />
          ) : (
            <p>No announcements found.</p>
          )}

          {currentClientCategory ===
            USER_TYPES_CATEGORIES.SERVICE_MARKETING && (
            <>
              <h2 className="h4 mt-3 tw-mb-5">My Achievements</h2>

              <div className="tw-mt-4 d-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-2 g-lg-4">
                {!!achievements.length ? (
                  achievements.map((achievement, index) => (
                    <AchievementCard
                      key={index}
                      title={achievement.title}
                      count={achievement.value}
                      unit={achievement.unit}
                      borderClasses={borderStyles[index % 4]}
                    />
                  ))
                ) : (
                  <p>No achievements found.</p>
                )}
              </div>
              <PointsToVoucherCard pointingWallet={pointingWallet} />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;
